import ThreadlessThreadViewWrapper from 'conversations-thread-view/thread-view/components/ThreadlessThreadViewWrapper';
// @ts-expect-error module not typed
import { provideThreadView } from 'conversations-thread-view/thread-view/decorators/provideThreadView';
import ThreadDataProvider from 'conversations-thread-data/common/ThreadDataProvider';
import { COMPOSITION_THREAD_ID } from 'conversations-thread-data/communicator/constants/compositionThreadId';
import { useComposerTrackingContext } from '../../../usage-tracking/hooks/useComposerTrackingContext';
import { ComposeEditor } from './ComposeEditor';
import { jsx as _jsx } from "react/jsx-runtime";
const BEACON_TRACKER = {};
const ComposeEditorWithThreadView = provideThreadView(ComposeEditor);
export function InlineComposeEditor({
  auth,
  associations,
  inboxId,
  onSend,
  renderExistingFileSelect,
  replyKey,
  tracker,
  useWhatsAppCompose,
  defaultMessageValue
}) {
  const ticketCount = associations.filter(({
    type
  }) => type === 'TICKET').length;
  const omnibusData = {
    currentInboxId: inboxId
  };
  useComposerTrackingContext({
    threadId: COMPOSITION_THREAD_ID,
    tracker,
    ticketCount
  });
  return /*#__PURE__*/_jsx(ThreadDataProvider, {
    children: /*#__PURE__*/_jsx(ThreadlessThreadViewWrapper, {
      auth: auth,
      beaconTracker: BEACON_TRACKER,
      omnibusData: omnibusData,
      tracker: tracker,
      children: /*#__PURE__*/_jsx(ComposeEditorWithThreadView, {
        associations: associations,
        inboxId: inboxId,
        onSend: onSend,
        renderExistingFileSelect: renderExistingFileSelect,
        replyKey: replyKey,
        useWhatsAppCompose: useWhatsAppCompose,
        defaultMessageValue: defaultMessageValue
      })
    })
  });
}
InlineComposeEditor.displayName = 'InlineComposeEditor';